import cx from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';

import useWindowSize from '#app/hooks/useWindowSize';

import styles from './index.module.scss';

const Header = ({ classNameWrapper }) => {
  const { isDesktop } = useWindowSize();

  return (
    <section className={cx(styles.wrapper, classNameWrapper)}>
      <div className={cx(styles.container)}>
        <a href="/">
          <LazyLoadImage
            effect="blur"
            alt="preview"
            width={isDesktop ? '150px' : '112px'}
            height={isDesktop ? '40px' : '50px'}
            src="/contactanos/layout/new-logo.png"
            placeholder={<Skeleton width="100%" height="100%" />}
          />
        </a>
      </div>
    </section>
  );
};

export default Header;
